import axios, {
  type Axios,
  type AxiosRequestConfig,
  type AxiosError,
  type AxiosResponse,
  type AxiosPromise,
} from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export interface MyAxiosInstance extends Axios {
  (config: AxiosRequestConfig): AxiosPromise;
  (url: string, config?: AxiosRequestConfig): AxiosPromise;
}

const unauthorizedRequest = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

unauthorizedRequest.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  async (error: AxiosError) => {
    return await Promise.reject(error.response?.data ?? error);
  }
);

export default unauthorizedRequest;
